import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportingService } from '../../services/reporting.service';
import { CommonService } from '../../services';
import { FileService } from '../../services/file.service';
import { Order } from '../../models/orders.model';
import { Subject } from 'rxjs';
import { Sort } from '@angular/material/sort';
import { NgProgress } from 'ngx-progressbar';
import { AuthService } from '../../services/auth.service';
import { CurrentUserModel } from '../../models/account-ledger.model';
import { TablefilterMultiplePipe } from '../../shared/pipes/tablefilter-multiple.pipe';
import { NgProgressService } from '../../services/ngProgress.service';

@Component({
  selector: 'app-backorder-reports',
  templateUrl: './backorder-reports.component.html',
  styleUrls: ['./backorder-reports.component.css']
})
export class BackorderReportsComponent implements OnInit, OnDestroy {

  title = 'ETA and Backorder Reports';

  loadingFinished = false;
  loadContent = false;

  backOrders: Order[] = [];
  sortedData: Order[] = [];
  accountId: string = '';

  orders: string[] = [];

  hasEmptyFilterResult: boolean = false;

  filterResultArr: any;

  newSortedData: Array<BackOrderModel> = [];

  goToOrderDetail: boolean = false;

  //search
  searchField: string;

  //export excel
  url: string;

  //unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private reportingService: ReportingService,
    private commonService: CommonService,
    private authService: AuthService,
    private fileService: FileService,
    private ngProgress: NgProgressService
  ) { }

  ngOnInit() {
    this.ngProgress.start();
    this.loadContent = false;

    this.authService.getLoginInfo()
      .subscribe((res: CurrentUserModel) => {
        this.accountId = res.accountId;
      },
        (error: any) => {
          console.info(error);
        });
    this.getBackOrders();

    this.ngProgress.done();
  }

  getBackOrders() {
    this.reportingService.getBackOrders().subscribe((value: Order[]) => {
      this.backOrders = value;
      this.sortedData = this.backOrders.slice();

      this.setUpViewModel(this.sortedData);

      this.loadContent = true;
    },
      (error: any) => {
        console.info(error);
        this.ngProgress.done();
        this.loadContent = true;
      });
  }

  copyToClipboard(item: any): void {
    let listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (item));
      e.preventDefault();
    };

    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }

  copyBackOrdersReportLink() {
    this.reportingService.copyBackOrdersReportLink().subscribe((res: string) => {
      if (res) {
        const downloadURL = window.location.origin + res;
        // console.log(downloadURL);
        this.copyToClipboard(downloadURL);
        this.commonService.implementToast("Backorder download link copied to clipboard successfully", "Success");
      }
    },
      (error: any) => {
        console.error(error);
        this.commonService.implementToast("Get Datafeeds CSV download url failed", "Error");
      });
  }

  exportBackOrdersReport() {
    this.ngProgress.start();

    this.reportingService.exportBackOrdersReport()
      .subscribe((data: any) => {

        const fileName = `DD_Backorders_${this.accountId}.xlsx`;

        this.fileService.saveAsExcelFile(data, fileName);
        this.ngProgress.done();

        this.commonService.implementToast('Backorder data downloaded successfully', 'Success');

      },
        (error: any) => {
          console.info(error);
          this.ngProgress.done();
        })
  }

  sortData(sort: Sort) {
    let data = this.backOrders.slice();

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'orderNo': return compare(a.orderNo.toLowerCase(), b.orderNo.toLowerCase(), isAsc);
        case 'orderSuffix': return compare(a.orderSuffix.toLowerCase(), b.orderSuffix.toLowerCase(), isAsc);
        case 'resellerPO': return compare(a.resellerPO.toLowerCase(), b.resellerPO.toLowerCase(), isAsc);
        case 'orderStatus': return compare(a.orderStatus.toLowerCase(), b.orderStatus.toLowerCase(), isAsc);
        case 'stockCode': return compare(a.stockCode.toLowerCase(), b.stockCode.toLowerCase(), isAsc);
        case 'stockDesc': return compare(a.stockDesc.toLowerCase(), b.stockDesc.toLowerCase(), isAsc);
        case 'lineQty': return compare(parseInt(a.lineQty), parseInt(b.lineQty), isAsc);
        case 'allocQty': return compare(parseInt(a.allocQty), parseInt(b.allocQty), isAsc);
        case 'backOrderQty': return compare(parseInt(a.backOrderQty), parseInt(b.backOrderQty), isAsc);
        case 'eta': return compare(a.eta.toLowerCase(), b.eta.toLowerCase(), isAsc);
        case 'etaCode': return compare(a.etaCode.toLowerCase(), b.etaCode.toLowerCase(), isAsc);
        default: return 0;
      }
    });
  }


  onChange() {
    this.filterResultArr = new TablefilterMultiplePipe().transform(this.newSortedData, ['orderNo', 'orderSuffix', 'resellerPO', 'orderStatus', 'stockLine.stockCode', 'stockLine.stockDesc', 'stockLine.eta'], this.searchField);
    if (this.filterResultArr.length === 0 && this.searchField !== '') {
      this.hasEmptyFilterResult = true;

    } else {
      this.hasEmptyFilterResult = false;
    }
  }

  filterReset() {
    this.searchField = "";
    this.hasEmptyFilterResult = false;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onLoading(currentLoadingStatus: boolean) {

    this.loadContent = !currentLoadingStatus;
  }

  close() {
    this.router.navigateByUrl('/reporting');
  }

  openOrderPage(orderNo: string, orderSuffix: string) {
    this.goToOrderDetail = true;
    this.router.navigateByUrl('/reporting/backorderreport/orderitemdetail/' + orderNo + orderSuffix);
  }

  setUpViewModel(data: any) {
    for (var i = 0; i < data.length; i++) {
      if (this.newSortedData.length === 0 || this.newSortedData[this.newSortedData.length - 1].orderNo + this.newSortedData[this.newSortedData.length - 1].orderSuffix !== 
                  data[i].orderNo + data[i].orderSuffix) {
        this.newSortedData.push({
          orderNo: data[i].orderNo,
          orderSuffix: data[i].orderSuffix,
          resellerPO: data[i].resellerPO,
          orderStatus: data[i].orderStatus,
          stockLines: [{
            stockCode: data[i].stockCode,
            stockDesc: data[i].stockDesc,
            lineQty: data[i].lineQty,
            allocQty: data[i].allocQty,
            backOrderQty: data[i].backOrderQty,
            eta: data[i].eta,
          }],
        });
      }
      else {
        this.newSortedData[this.newSortedData.length - 1].stockLines.push({
          stockCode: data[i].stockCode,
          stockDesc: data[i].stockDesc,
          lineQty: data[i].lineQty,
          allocQty: data[i].allocQty,
          backOrderQty: data[i].backOrderQty,
          eta: data[i].eta,
        });
      }
    }
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

interface BackOrderModel {
  orderNo: string;
  orderSuffix: string;
  resellerPO: string;
  orderStatus: string;
  stockLines: Array<BackOrderStockLine>;
}

interface BackOrderStockLine {
  stockCode: string;
  stockDesc: string;
  lineQty: string;
  allocQty: string;
  backOrderQty: string;
  eta: string;
}
